import { useEffect, useState } from "react";
import { CustomerStaticData } from "../models/customer";

export function useGetCustomerStaticData() {
    const [customerStaticData, setCustomerStaticData] =
        useState<CustomerStaticData>({});

    useEffect(() => {
        const customerEmail = (window as any).customerEmail || null;
        const loggedInCustomerId = (window as any).loggedInCustomerId || null;
        const bcCustomerNumber = (window as any).bcCustomerNumber || null;

        setCustomerStaticData({
            customerEmail,
            loggedInCustomerId,
            bcCustomerNumber,
        });
    }, []);

    return { customerStaticData };
}
